export interface DomainsDescriptionsTreeConfig {
  isWithCheckboxes: boolean;
  areCheckboxesDisabled: boolean;
}

export namespace DomainsDescriptionsTreeConfig {
  export const DEFAULT = {
    isWithCheckboxes: true,
    areCheckboxesDisabled: false,
  } satisfies DomainsDescriptionsTreeConfig;
}
